import { z } from "zod";

export type ConversationEngine = "assistant" | "legacy";

// The assistant engine mints UUIDs, the legacy one 24-hex object ids.
export function conversationIdEngine(id: string): ConversationEngine {
  return z.uuid().safeParse(id).success ? "assistant" : "legacy";
}
